import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/nail_bar_demo',
		name: 'Nail Bar Demo',
		component: () => import('../views/NailBarDemo.vue'),
	},
	{
		path: '/ee_demo',
		name: 'E & E Demo',
		component: () => import('../views/eeDemo.vue'),
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

export default router
